var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleTagManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB4F8",
    d: "m13.744 21.236-3.473-3.475 7.46-7.534 3.537 3.535-7.524 7.474Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.767 6.268 10.23 2.732l-7.498 7.495a2.497 2.497 0 0 0 0 3.535l7.498 7.495 3.469-3.483L8.033 12l5.734-5.732Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB4F8",
    d: "m21.263 10.227-7.497-7.495a2.501 2.501 0 0 0-3.537 3.535l7.502 7.495a2.5 2.5 0 0 0 3.536-3.535h-.004Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#246FDB",
    d: "M11.97 21.996a2.478 2.478 0 1 0 .001-4.956 2.478 2.478 0 0 0 0 4.956Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTagManager);
export default __webpack_public_path__ + "static/media/GoogleTagManager.30c5fa6072d6d4f155dda4b9b804a8bc.svg";
export { ForwardRef as ReactComponent };